/**
 * Utilitários compartilhados para serviços
 */

/**
 * Regex para validar UUID v4
 */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Verifica se um ID é um UUID válido
 */
export const isValidUUID = (id: string | undefined | null): boolean => {
    if (!id) return false;
    return UUID_REGEX.test(id);
};

/**
 * Verifica se uma entidade é nova (não tem ID válido)
 */
export const isNewEntity = (id: string | undefined | null): boolean => {
    return !isValidUUID(id);
};

/**
 * Loga erro e lança exceção com mensagem em português
 */
export const handleServiceError = (operation: string, error: any): never => {
    console.error(`Error ${operation}:`, error);
    throw new Error(`Erro ao ${operation}: ${error.message}`);
};

/**
 * Formata data para padrão brasileiro
 */
export const formatDateBR = (date: string | Date | null | undefined): string => {
    if (!date) return '-';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('pt-BR', {
        day: 'numeric',
        month: 'short',
        year: '2-digit'
    });
};

/**
 * Formata data e hora para padrão brasileiro
 */
export const formatDateTimeBR = (date: string | Date): string => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleString('pt-BR');
};
